import { extend } from 'flarum/common/extend';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';

// Unused sort options, dropped from the "Activité" dropdown - core's own
// DiscussionListState.sortMap() (js/src/forum/states/DiscussionListState.ts)
// adds `az`/`za` (Title A-Z/Z-A) unconditionally alongside latest/top/newest/oldest.
// The map is a plain object handed back by reference, so deleting the keys
// here removes them from IndexPage's own sortOptions - it derives the
// dropdown's entries straight from Object.keys(sortMap()) - with nothing
// else to touch.
export default function removeTitleSort() {
  extend(DiscussionListState.prototype, 'sortMap', map => {
    delete map.az;
    delete map.za;
  });
}